import { useState } from 'react';
import { Button, Form, Input, PageHeader, Spin } from 'antd';
import api from '@/api';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

const UserPasswordPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state: RootState) => state.account);

  const onFinish = (values: any) => {
    setLoading(true);
    api
      .post('/user/password', 'puser.PbUserPasswordChangeRequest', {
        oldPassword: values.current,
        newPassword: values.password,
      })
      .then(() => {
        setLoading(false);
        console.log('success');
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className="h-full flex justify-center">
      <div className="w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <Spin spinning={user === null || loading}>
          <PageHeader title="Change password">
            <Form onFinish={onFinish} style={{ width: '95%', maxWidth: '320px' }} layout="vertical" form={form}>
              <Form.Item
                label="Current password"
                name="current"
                hasFeedback
                validateFirst
                rules={[{ required: true, message: '현재 비밀번호를 입력하세요.' }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="New password"
                name="password"
                rules={[
                  { required: true, message: '비밀번호를 입력하세요.' },
                  { min: 6, message: '6자 이상 입력하세요.' },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Confirm password"
                name="passwordConfirm"
                dependencies={['password']}
                rules={[
                  { required: true, message: '비밀번호를 입력하세요.' },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading} disabled={loading} style={{ margin: '20px auto' }}>
                  저장
                </Button>
              </Form.Item>
            </Form>
          </PageHeader>
        </Spin>
      </div>
    </div>
  );
};

export default UserPasswordPage;
